(function () {
  'use strict';

  var bundleCache = {};

  function extractBalancedJSON(html, marker) {
    var idx = html.indexOf(marker);
    if (idx === -1) return null;
    var eqIdx = html.indexOf('=', idx);
    if (eqIdx === -1) return null;
    var braceStart = html.indexOf('{', eqIdx);
    if (braceStart === -1) return null;
    var depth = 0, inStr = false, strCh = '', esc = false;
    for (var i = braceStart; i < html.length; i++) {
      var c = html[i];
      if (inStr) {
        if (esc) { esc = false; }
        else if (c === '\\') { esc = true; }
        else if (c === strCh) { inStr = false; }
        continue;
      }
      if (c === '"' || c === "'" || c === '`') { inStr = true; strCh = c; continue; }
      if (c === '{') { depth++; }
      else if (c === '}') {
        depth--;
        if (depth === 0) { return html.slice(braceStart, i + 1); }
      }
    }
    return null;
  }

  function getBundleOffers(productId, handle) {
    var cacheKey = String(productId);
    if (bundleCache[cacheKey]) return bundleCache[cacheKey];
    var globalKey = 'rapi_bundle_' + productId;
    if (window[globalKey] && Array.isArray(window[globalKey].offers)) {
      bundleCache[cacheKey] = Promise.resolve(window[globalKey].offers);
      return bundleCache[cacheKey];
    }
    bundleCache[cacheKey] = fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var json = extractBalancedJSON(html, 'rapi_bundle_' + productId);
        if (!json) return null;
        try {
          var data = JSON.parse(json);
          return (data && Array.isArray(data.offers)) ? data.offers : null;
        } catch (e) { return null; }
      })
      .catch(function () { return null; });
    return bundleCache[cacheKey];
  }

  function formatMoneyLike(sampleText, cents) {
    var sign = cents < 0 ? '-' : '';
    var abs = Math.abs(Math.round(cents));
    var intPart = Math.floor(abs / 100).toString();
    var decPart = (abs % 100).toString();
    if (decPart.length < 2) decPart = '0' + decPart;
    var m = sampleText.match(/[.,](\d{2})(?!\d)/);
    var sep = m ? m[0].charAt(0) : ',';
    var newNumber = intPart + sep + decPart;
    var numRe = /[\d.,]+/;
    if (numRe.test(sampleText)) {
      return sign + sampleText.replace(numRe, newNumber);
    }
    return sign + newNumber;
  }

  function enhanceRow(row, cartItem) {
    try {
      if (row.dataset.rapiChecked === '1') {
        return Promise.resolve(parseInt(row.dataset.rapiSavings || '0', 10) || 0);
      }
      if (!cartItem.properties || !cartItem.properties.__rapi_offer) return Promise.resolve(0);
      var offerMeta;
      try { offerMeta = JSON.parse(cartItem.properties.__rapi_offer); } catch (e) { return Promise.resolve(0); }
      if (!offerMeta || !offerMeta.offer) return Promise.resolve(0);

      var priceDiv = row.querySelector('.cart-item__price-wrapper > .cart-item__price');
      if (!priceDiv) return Promise.resolve(0);

      if (priceDiv.querySelector('s')) {
        row.dataset.rapiChecked = '1';
        row.dataset.rapiSavings = '0';
        return Promise.resolve(0);
      }

      row.dataset.rapiChecked = '1';

      return getBundleOffers(cartItem.product_id, cartItem.handle).then(function (offers) {
        if (!offers) { row.dataset.rapiSavings = '0'; return 0; }
        var offer = null;
        for (var i = 0; i < offers.length; i++) {
          if (offers[i].identifier_id === offerMeta.offer) { offer = offers[i]; break; }
        }
        if (!offer || !offer.manual_compare_at_price) { row.dataset.rapiSavings = '0'; return 0; }
        var unitOriginal = parseFloat(offer.manual_compare_at_price);
        if (!unitOriginal || isNaN(unitOriginal)) { row.dataset.rapiSavings = '0'; return 0; }
        var compareAtLineCents = Math.round(unitOriginal * 100) * cartItem.quantity;
        var currentLineCents = cartItem.final_line_price;
        var originalLineCents = cartItem.original_line_price;
        if (compareAtLineCents <= originalLineCents) { row.dataset.rapiSavings = '0'; return 0; }

        var priceSpan = priceDiv.querySelector('.price');
        var sampleText = priceSpan ? priceSpan.textContent.trim() : (currentLineCents / 100).toFixed(2).replace('.', ',');

        var oldEl = document.createElement('s');
        oldEl.className = 'cart-item__old-price price price--end';
        oldEl.setAttribute('style', 'margin-right:6px;opacity:.6;');
        oldEl.textContent = formatMoneyLike(sampleText, compareAtLineCents);
        priceDiv.insertBefore(oldEl, priceSpan || priceDiv.firstChild);

        var diff = compareAtLineCents - originalLineCents;
        row.dataset.rapiSavings = String(diff);
        return diff;
      }).catch(function () { row.dataset.rapiSavings = '0'; return 0; });
    } catch (e) {
      return Promise.resolve(0);
    }
  }

  function upsertDiscountRow(extraSavingsCents) {
    try {
      var footer = document.querySelector('.cart-drawer__footer');
      if (!footer) return;

      var duplicate = footer.querySelector('[data-rapi-savings-row]');
      if (duplicate) duplicate.remove();

      var row = footer.querySelector('.totals--savings');
      if (!row && extraSavingsCents > 0) {
        var totalsTotalEl = footer.querySelector('.totals__total');
        var totalsContainer = totalsTotalEl && totalsTotalEl.closest('.totals');
        if (!totalsContainer || !totalsContainer.parentNode) return;
        row = document.createElement('div');
        row.className = 'totals totals--savings';
        row.setAttribute('role', 'status');
        row.dataset.baseSavings = '0';
        row.innerHTML = '<span class="totals__savings-label">Te ahorras</span><span class="totals__savings-value"></span>';
        totalsContainer.parentNode.insertBefore(row, totalsContainer);
      }
      if (!row) return;

      var valueEl = row.querySelector('.totals__savings-value');
      if (!valueEl) return;
      var baseSavingsCents = parseInt(row.dataset.baseSavings || '0', 10) || 0;
      var totalSavingsCents = baseSavingsCents + extraSavingsCents;
      var sampleText = valueEl.textContent.trim().replace(/^-/, '');
      if (!sampleText) {
        var totalValueEl = footer.querySelector('.totals__total-value');
        sampleText = totalValueEl ? totalValueEl.textContent.trim() : '€0,00';
      }
      var newText = formatMoneyLike(sampleText, -totalSavingsCents);
      if (valueEl.textContent !== newText) valueEl.textContent = newText;
    } catch (e) { }
  }

  function runEnhancement() {
    var rows = document.querySelectorAll('#CartDrawer-CartItems tr.cart-item');
    if (!rows.length) {
      var existingRow = document.querySelector('.cart-drawer__footer [data-rapi-savings-row]');
      if (existingRow) existingRow.remove();
      return;
    }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var tasks = [];
        rows.forEach(function (row, i) {
          var item = cart.items[i];
          if (item) tasks.push(enhanceRow(row, item));
        });
        Promise.all(tasks).then(function (values) {
          var total = 0;
          values.forEach(function (v) { total += (v || 0); });
          upsertDiscountRow(total);
        });
      })
      .catch(function () { });
  }

  var debounceTimer = null;
  function scheduleRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runEnhancement, 300);
  }

  function init() {
    var observer = new MutationObserver(scheduleRun);
    observer.observe(document.body, { childList: true, subtree: true });
    scheduleRun();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
